import api from "@v2/lib/api";
import { cache } from "react";
import { MenuItemType } from "./types";

export const getHeader = cache(async (url?: string): Promise<MenuItemType[]> => {
	const response = await fetch(url ?? api.menu, {
		next: {
			tags: [url ? "blog-header" : "header"],
			revalidate: 3600 * 24,
		},
	});
	if (!response.ok) return [];
	const json = await response.json();
	return json.data;
});
